import * as React from 'react';
import { InputHTMLAttributes, ReactNode } from 'react';
import { BaseFieldProps, Field, GenericField, WrappedFieldProps } from 'redux-form';
import { FieldWrapper, FieldWrapperConfig } from './FieldWrapper';
import classNames from 'classnames';

/**
 * Input props
 */
export interface InputComponentProps extends InputHTMLAttributes<HTMLInputElement> {
    inputStyle?: AnyObject | string;
    inputErrorStyle?: AnyObject | string;
    wrapperConfig?: FieldWrapperConfig;
    propsRef?: any;
    input?: any;
    disabled?: boolean;

    children?: ReactNode;
}

type InputProps = InputComponentProps & WrappedFieldProps;

/**
 * InputComponent which renders wrapped input field with label and error
 *
 * @constructor
 */
const InputComponent: React.FunctionComponent<InputProps> = (props: InputProps) => {
    const hasError = !props.meta.valid && props.meta.touched;
    let stepAny = {};
    if (props.type === 'number') {
        stepAny = { step: 'any' };
    }
    return (
        <FieldWrapper
            {...props.wrapperConfig}
            classes={props.wrapperConfig?.classes || {}}
            name={props.input.name}
            meta={props.meta}
        >
            <input
                id={props.id || undefined}
                {...props.input}
                disabled={props.disabled}
                className={classNames(props.inputStyle, hasError && props.inputErrorStyle)}
                placeholder={props.placeholder}
                type={props.type}
                {...stepAny}
                minLength={props.min ? +props.min : undefined}
                maxLength={props.max ? +props.max : undefined}
                min={props.min ? props.min : undefined}
                max={props.max ? props.max : undefined}
                accept={props.accept}
                value={props.type === 'file' ? undefined : props.input.value}
            />
            {props.children}
        </FieldWrapper>
    );
};

InputComponent.defaultProps = {
    inputStyle: 'form-control',
    inputErrorStyle: 'border-danger',
};

const FieldInputComponent = Field as new () => GenericField<InputComponentProps>;

type FieldProps = BaseFieldProps<InputComponentProps> & InputComponentProps;

/**
 * FieldInput component which extends GenericField from redux form and renders input field
 * (InputComponent) with all needed props
 *
 * @param props
 * @constructor
 */
export const FieldInput: React.FunctionComponent<FieldProps> = (props: FieldProps) => (
    <FieldInputComponent ref={props.propsRef} {...props} component={InputComponent} />
);
